window.aguadecoco = window.aguadecoco || {};

function internalRegisterSession() {
  return fetch('/api/sessions/', {
    method: 'POST',
    headers: {
      accept: '*/*',
      'accept-language': 'pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7',
      'content-type': 'application/json',
      'cache-control': 'no-cache',
      pragma: 'no-cache',
    },
    referrer: window.location.href,
    referrerPolicy: 'no-referrer-when-downgrade',
    mode: 'cors',
    credentials: 'include',
    body: '{"public":{}}',
  });
}

/**
 * Realiza logout do usuário atualmente autenticado
 */

export async function logout() {
  const $document = $(document);
  await fetch(
    `/api/vtexid/pub/logout?scope=${window?.vtxctx?.transurl}&returnUrl=${window?.vtxctx?.transurl}
  `,
    {
      headers: {
        accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
        'accept-language': 'pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7',
        'cache-control': 'no-cache',
        pragma: 'no-cache',
        'sec-fetch-dest': 'document',
        'sec-fetch-mode': 'navigate',
        'sec-fetch-site': 'same-origin',
        'sec-fetch-user': '?1',
        'upgrade-insecure-requests': '1',
      },
      referrer: window.location.href,
      referrerPolicy: 'no-referrer-when-downgrade',
      body: null,
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      redirect: 'manual',
    },
  ).then(() => {
    // HTTP 30x response
    return false;
  });

  //seta novo id para quando o usuario desloga

  function uuidv4() {
    return `${[1e7]}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, (c) =>
      // @ts-ignore
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    );
  }

  // eslint-disable-next-line no-useless-escape
  await fetch('/api/checkout/pub/orderForm/' + uuidv4().replace(/\-/, '') + '?refreshOutdatedData=true', {
    headers: {
      accept: 'application/json, text/javascript, */*; q=0.01',
      'cache-control': 'no-cache',
      'content-type': 'application/json; charset=UTF-8',
    },
    referrer: window.location.href,
    body: '{}',
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
  });

  await internalRegisterSession();
  $document.trigger('userAuthChanged', { authenticated: false });
  $document.trigger('userAuthLogout');
  setTimeout(() => {
    window.location.reload();
  }, 100);
}

Object.assign(window.aguadecoco, {
  user: Object.assign(window.aguadecoco.user || {}, {
    isAuthenticated: null,
    data: {},
  }),
});

(() => {
  const $document = $(document);

  $document.on('click', '.logout', (event) => {
    event.preventDefault();
    logout();
  });

  $document.on('click', '.open-modal-login', (event) => {
    event.preventDefault();
    window.location.href = `/login?ReturnUrl=${encodeURIComponent(
      `${window.location.pathname}${window.location.search}${window.location.hash}`,
    )}`;
  });

  $.ajaxSetup({
    dataFilter: function (data, type) {
      try {
        if (data && type === 'json' && data.indexOf('isAuthenticated') > -1 && data.indexOf('namespaces') > -1) {
          const jsonData = JSON.parse(data);
          if (jsonData?.namespaces?.profile?.isAuthenticated?.value === 'true') {
            window.aguadecoco.user.isAuthenticated = true;
            window.aguadecoco.user.data = jsonData;
            $(document).find('body').addClass('user-logged');
            $(document).find('body').removeClass('user-not-logged');
            // const name = '';
            // if (vtexjs.checkout.orderForm) {
            //   // name = vtexjs.checkout.orderForm.clientProfileData.firstName;
            // } else {
            //   // name = (await window.vtexjs.checkout.getOrderForm())?.clientProfileData?.firstName;
            // }
            // $(document)
            //   .find('.header-user-area-welcome')
            //   .text('Olá' + name);
          } else {
            window.aguadecoco.user.isAuthenticated = false;
            $(document).find('body').removeClass('user-logged');
            $(document).find('body').addClass('user-not-logged');
          }
          $(window).trigger('user.storeTheme');
        }
      } catch (e) {
        console.error('🛑 ERROR', e);
      }

      return data;
    },
  });
})();

export default {};
